module.exports = __webpack_public_path__ + "img/im_logo@2x.3a798eff.png";